export const deepTrim = (value) => {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (Array.isArray(value)) {
    return value.map(deepTrim);
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        typeof key === 'string' ? key.trim() : key,
        deepTrim(entry)
      ])
    );
  }
  return value;
};

export const parseTrimmed = (json, fallback = {}) => {
  if (!json) {
    return fallback;
  }
  return deepTrim(JSON.parse(json));
};
